<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import StatePanel from '../components/StatePanel.vue'
import VenueCard from '../components/VenueCard.vue'
import { api, listOf } from '../services/api'

const tab = ref<'favorites' | 'visited'>('favorites')
const items = ref<any[]>([])
const loading = ref(true)
const error = ref('')
async function load() {
  loading.value = true; error.value = ''
  try { items.value = listOf(await api(`/venues/${tab.value}?page=1&pageSize=50`)) }
  catch (reason: any) { error.value = reason?.message || '加载失败' }
  finally { loading.value = false }
}
watch(tab, load); onMounted(load)
</script>

<template><div class="shell subpage"><div class="subpage-head"><div><span class="section-kicker">MY COURTS</span><h1>收藏与到过</h1><p>保存想去的场馆，也快速回到熟悉的球场。</p></div><div class="segmented"><button :class="{ active: tab === 'favorites' }" @click="tab = 'favorites'">我的收藏</button><button :class="{ active: tab === 'visited' }" @click="tab = 'visited'">我到过的</button></div></div><StatePanel v-if="loading" mode="loading" /><StatePanel v-else-if="error" mode="error" :description="error" @retry="load" /><div v-else-if="items.length" class="card-grid venue-grid"><VenueCard v-for="item in items" :key="item.id" :venue="item" /></div><StatePanel v-else mode="empty" :title="tab === 'favorites' ? '还没有收藏场馆' : '还没有到过记录'" description="去找球页看看附近的场地。" /></div></template>
